import { SerializedStyles, Theme } from "@emotion/react";
import { ThemedCssCreator } from "src/config/emotion";

type CssArray = (ThemedCssCreator | boolean | SerializedStyles)[];
type CompositeCssCreator = (theme: Theme) => SerializedStyles[];

// Emotion nativně umožňuje do css propu ThemedCssCreator nebo pole css``
// interpolací, ale z nějakého důvodu přes TS neprojde pole ThemedCssCreatorů
// - tahle wrapper funkce to obchází
// eslint-disable-next-line import/prefer-default-export
export function applyCss(cssIn: CssArray): CompositeCssCreator {
  return (theme: Theme) => {
    const arrOfStyles = [] as (ThemedCssCreator | SerializedStyles)[];

    cssIn.forEach((cssEntry) => {
      if (typeof cssEntry !== "boolean") {
        arrOfStyles.push(cssEntry);
      }
    });
    return arrOfStyles.map((member) => {
      if (typeof member === "function") return member(theme);
      return member;
    });
  };
}
